module.exports = __webpack_public_path__ + "static/media/Award Press_8 col X 10 in_Final_Bangla-03.c5f37864.jpg";